export type RequestMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

export enum HttpStatus {
  OK = 200,
  CREATED = 201,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,
  TOO_MANY_REQUESTS = 429,
  INTERNAL_SERVER_ERROR = 500,
}

interface NextFetchRequestConfig {
  revalidate?: number | false;
  tags?: string[];
}

interface RequestInit {
  next?: NextFetchRequestConfig | undefined;
}

export interface FetchOptions extends Omit<RequestInit, 'body'> {
  body?: unknown;
  headers?: HeadersInit;
  timeout?: number;
  credentials?: RequestCredentials;
  // retries?: number;
  params?: Record<string, string | number | boolean | string[] | null | undefined>;
}

export interface ApiResponse<T = unknown> {
  data: T;
  status: number;
  message?: string;
}

export interface ApiError {
  status: number;
  message: string;
  errors?: Record<string, string[]>;
}

// export type FetchArgs = [string | URL, RequestInit | undefined];

export interface HttpClientConfig {
  baseURL: string;
  timeout?: number;
  options?: FetchOptions;
  // retries?: number;
  headers?: HeadersInit;
  // interceptors?: {
  //   request?: (requestArgs: FetchArgs, fetch: typeof window.fetch) => Promise<FetchArgs>;
  //   response?: (response: Response, requestArgs: FetchArgs, fetch: typeof window.fetch) => Promise<Response>;
  // };
}

export interface FetchClient {
  get: (url: string, options?: FetchOptions) => Promise<Response>;
  post: (url: string, options?: FetchOptions) => Promise<Response>;
  put: (url: string, options?: FetchOptions) => Promise<Response>;
  patch: (url: string, options?: FetchOptions) => Promise<Response>;
  delete: (url: string, options?: FetchOptions) => Promise<Response>;
}

export type ResponseType<T> = {
  success: boolean;
  data: T;
};
